/*
 * Login through Keycloak (realm mimer-contacts) with the API as backend-for-frontend: Keycloak
 * sends the code to /mina-sidor/callback, the API exchanges it and keeps the tokens in httpOnly
 * cookies, so the app never holds a token.
 */
const keycloakUrl = process.env.VUE_APP_KEYCLOAK_URL;
const realm = process.env.VUE_APP_KEYCLOAK_REALM || 'mimer-contacts';
const clientId = process.env.VUE_APP_KEYCLOAK_CLIENT_ID || 'mina-sidor';

const PENDING_LOGIN_KEY = 'keycloak_login';

// A regex rather than a comparison: the Docker image fills in the URL after the build, so the
// minifier must not be able to fold this check away.
export const isKeycloakLogin = () => /^https?:\/\//.test(keycloakUrl || '');

// Must match the API's BffConfiguration.CallbackPath.
export const callbackUri = () => location.origin + '/mina-sidor/callback';

const base64Url = (bytes) =>
    btoa(String.fromCharCode(...new Uint8Array(bytes)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');

const randomString = () => base64Url(crypto.getRandomValues(new Uint8Array(32)));

export const startKeycloakLogin = async () => {
    const state = randomString();
    const codeVerifier = randomString();
    const codeChallenge = base64Url(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier)));
    sessionStorage.setItem(PENDING_LOGIN_KEY, JSON.stringify({ state, codeVerifier }));

    const params = new URLSearchParams({
        client_id: clientId,
        response_type: 'code',
        scope: 'openid',
        redirect_uri: callbackUri(),
        state,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
    });
    location.assign(`${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth?${params}`);
};

/**
 * The PKCE verifier for this callback, usable once. Null when the state does not match a login
 * started in this tab.
 */
export const takePendingLogin = (state) => {
    let pending = null;
    try {
        pending = JSON.parse(sessionStorage.getItem(PENDING_LOGIN_KEY));
    } catch (err) {
        pending = null;
    }
    sessionStorage.removeItem(PENDING_LOGIN_KEY);
    return pending && state && pending.state === state ? pending.codeVerifier : null;
};
